var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Dialog",
    {
      staticClass: "_component-welfare",
      attrs: { size: "big", title: "限时福利" },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "content-wrap" },
        [
          _c(
            "div",
            { staticClass: "welfares-wrap" },
            _vm._l(_vm.welfares, function(item, index) {
              return _c("div", { key: index, staticClass: "welfare-item" }, [
                _c("div", { staticClass: "item-img-wrap img-wrap" }, [
                  _c("img", { attrs: { src: item.img, alt: "" } })
                ]),
                _c("div", { staticClass: "item-info-wrap" }, [
                  _c("div", { staticClass: "item-info-top" }, [
                    _c("div", { staticClass: "item-name-wrap" }, [
                      _c("h3", { staticClass: "h3 color-black-1" }, [
                        _vm._v(_vm._s(item.name))
                      ]),
                      item.tag
                        ? _c("div", { staticClass: "name-tag" }, [
                            _vm._v(_vm._s(item.tag))
                          ])
                        : _vm._e()
                    ]),
                    _c("div", {
                      staticClass: "text3 color-gray-2 mt-5",
                      domProps: { innerHTML: _vm._s(item.desc) }
                    })
                  ]),
                  _c("div", { staticClass: "item-info-footer" }, [
                    _c("div", { staticClass: "footer-left" }, [
                      item.count
                        ? _c(
                            "div",
                            { staticClass: "hot-count-wrap text2 bold" },
                            [_vm._v(" " + _vm._s(item.count) + " ")]
                          )
                        : _vm._e()
                    ]),
                    item.tip
                      ? _c("p", { staticClass: "text2 color-gray-2" }, [
                          _vm._v(_vm._s(item.tip))
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            }),
            0
          ),
          _c(
            "Button",
            {
              staticClass: "btn-next",
              on: {
                click: function($event) {
                  return _vm.$emit("submit")
                }
              }
            },
            [_vm._v("申请并领取")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }